

import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from './AdminLayout';
import { FiFilter, FiRotateCw, FiPlus, FiSearch, FiChevronDown, FiX, FiTrash2 } from "react-icons/fi";
import { Loader2 } from "lucide-react"; // Import Loader2 for the assign button spinner
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { es } from 'date-fns/locale';
import check from "../../assets/check.svg";
import { useNavigate } from 'react-router-dom';
import { 
  addShipment, 
  getTeamMembers, 
  getAllShipment, 
  getShipment, 
  updateShipmentDetails, 
  getShippingLineList, 
  addDispatchShipment,
  assignedShipmentToDriver // Used here for assign driver API
} from '../../ApiController/ApiService';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import UpdateSealNumberModal from './UpdateSealNumberModal';
import { useDashboard } from '../Context/Dashboardcontext';
import CreateContainerModal from '../OrderContainers/CreateOrderModal';
import FTLModal from '../OrderContainers/FTLModal';
import LTLModal from '../OrderContainers/LTLModal';

// Fix Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
});

const statusColors = {
  'In Transit': 'bg-blue-500',
  'Delivered': 'bg-green-500',
  'Delayed': 'bg-red-500',
  'Pending': 'bg-yellow-400',
};

const OrdersContainers = () => {
  const { t } = useTranslation();
  const { selectedLanguage } = useContext(LanguageContext);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const calendarRef = useRef(null);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const buttonRef3 = useRef(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [selectedTab, setSelectedTab] = useState('Import');
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [selectedShipping, setSelectedShipping] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [loadingDrivers, setLoadingDrivers] = useState(false);
  const [driverError, setDriverError] = useState('');

  // --- NEW STATES FOR ASSIGN DRIVER MODAL ---
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [assigningShipmentId, setAssigningShipmentId] = useState(null);
  const [assigningDriverId, setAssigningDriverId] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);
  // ------------------------------------------

  // --- UPDATED FORM DATA STATE ---
  const [formData, setFormData] = useState({
    importExportType: 'import',
    orderId: '',
    origin: '',
    originLat: '',
    originLng: '',
    destination: '',
    destinationLat: '',
    destinationLng: '',
    description: '',
    goodsType: '',
    pickUpDate: '',
    dropOffDate: '',
    pickUpHours: '',
    dropOffHours: '',
    companyType: "Dispax",

    // Array for multiple containers
    containers: [
      {
        containerNumber: '',
        containerType: '',
        sealNumber: '',
        weight: '',
        noOfPallets: '',
        containerComments: ''
      }
    ],

    length: '',
    commodity: '',
    intermediateDestinations: [{ destination: '', time: '', lat: '', lng: '' }],
    terminal: '',
    routeNotes: '',
    driverId: '',
    vehicleNumber: '',
    driverContactNumber: '',
    contactNumber: '',
    countryCode: '+1',
    currentLocation: { type: 'Point', coordinates: [0, 0] },
    destinationLocation: { type: 'Point', coordinates: [0, 0] },
    addOnDate: '',
    estimateDeliveryDate: '',
    portName: '',
    ticketNumber: '',
    bookingNumber: '',
    sl: '',
    price: '',
    isTracking: true,
    status: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState(null);
  const [shipments, setShipments] = useState([]);
  const [allShipmentsForFilters, setAllShipmentsForFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [uniqueStatuses, setUniqueStatuses] = useState([]);
  const [showMapModal, setShowMapModal] = useState(false);
  const [mapType, setMapType] = useState('');
  const [mapIndex, setMapIndex] = useState(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [mapSearchQuery, setMapSearchQuery] = useState('');
  const [mapSuggestions, setMapSuggestions] = useState([]);
  const [isSearchingMap, setIsSearchingMap] = useState(false);
  const [showSealModal, setShowSealModal] = useState(false);
  const [shippingLines, setShippingLines] = useState([]);

  const [showLTLModal, setShowLTLModal] = useState(false);
  const [showFTLModal, setShowFTLModal] = useState(false);

  const { userProfile } = useDashboard();

  const [formDatas, setFormDatas] = useState({
    // General fields
    companyType: "Dispax",
    importExportType: 'import',
    orderId: '',
    origin: '',
    originLat: '',
    originLng: '',
    destination: '',
    destinationLat: '',
    destinationLng: '',
    description: '',
    noOfPallets: '',
    weightInTons: '',
    goodsType: '',
    pickUpDate: '',
    dropOffDate: '',
    pickUpHours: '',
    dropOffHours: '',
    containerType: '',
    containerComments: '',
    containerNumber: '',
    length: '',
    weight: '',
    commodity: '',
    terminal: '',
    routeNotes: '',
    driverId: '',
    vehicleNumber: '',
    driverContactNumber: '',
    currentLocation: { type: 'Point', coordinates: [0, 0] },
    destinationLocation: { type: 'Point', coordinates: [0, 0] },
    addOnDate: '',
    estimateDeliveryDate: '',
    portName: '',
    ticketNumber: '',
    price: '',
    isTracking: true,
    status: '',

    // Nested structured fields
    ltl: {
      shippingMethod: '',
      shippingMethod1: '',
      pickEmpty: '',
      sl: '',
      size: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      commodity: '',
      returnFull: '',
      trailerNumber: '',
      bookingNumber: '',
      destination: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      sealNumber: '',
      flatBeds: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    ftl: {
      shippingMethod: '',
      shippingMethod1: '',
      pickEmpty: '',
      sl: '',
      size: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      commodity: '',
      sealNumber: '',
      returnFull: '',
      trailerNumber: '',
      bookingNumber: '',
      destination: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      flatBeds: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '', stopType: '' }],
    },
    export: {
      sl: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      destination: '',
      dispatchMode: '',
      containers: [
        {
          bookingNumber: '',
          size: '',
          pickEmpty: '',
          commodity: '',
          returnFull: '',
        },
      ],
      intermediateDestinations: [{ destination: '', time: '' }],
    },
    import: {
      sl: '',
      size: '',
      pinNumber: '',
      importLocation: '',
      poNumber: '',
      loadDate: '',
      loadTime: '',
      loadAddress: '',
      destination: '',
      commodity: '',
      returnFull: '',
      dispatchMode: '',
      intermediateDestinations: [{ destination: '', time: '' }],
    },
  });

  // --- NEW HANDLER FUNCTIONS FOR MULTIPLE CONTAINERS ---

  const handleContainerChange = (e, index) => {
    const { name, value } = e.target;
    const updatedContainers = [...formData.containers];
    updatedContainers[index][name] = value;
    setFormData({ ...formData, containers: updatedContainers });
  };

  const addContainerRow = () => {
    if (formData.containers.length < 20) {
      setFormData({
        ...formData,
        containers: [
          ...formData.containers,
          {
            containerNumber: '',
            containerType: '',
            sealNumber: '',
            weight: '',
            noOfPallets: '',
            containerComments: ''
          }
        ]
      });
    } else {
      toast.warning(t('orders.maxLimitReached') || "Max 20 containers allowed");
    }
  };

  const removeContainerRow = (index) => {
    if (formData.containers.length > 1) {
      const updatedContainers = formData.containers.filter((_, i) => i !== index);
      setFormData({ ...formData, containers: updatedContainers });
    }
  };

  // --------------------------------------------------------

  const handleViewShipment = async (id) => {
    try {
      setModalLoading(true);
      setModalError(null);
      const shipmentData = await getShipment(id);
      setSelectedShipment(shipmentData);
      setFormData({
        ...formData, // keep existing structure
        Id: shipmentData.Id || '',
        orderId: shipmentData.orderId || '',
        noOfPallets: shipmentData.noOfPallets || '',
        goodsType: shipmentData.goodsType || '',
        addOnDate: shipmentData.addOnDate ? new Date(shipmentData.addOnDate).toISOString().slice(0, 16) : '',
        estimateDeliveryDate: shipmentData.estimateDeliveryDate ? new Date(shipmentData.estimateDeliveryDate).toISOString().slice(0, 16) : '',
        store: shipmentData.store || '',
        estimatedTimeAccurate: shipmentData.estimatedTimeAccurate || '',
        status: shipmentData.status || '',
        intermediateDestinations: shipmentData.intermediateDestinations?.length > 0
          ? shipmentData.intermediateDestinations
            .map((stop) => `${stop.destination} - ${new Date(stop.time).toLocaleString(selectedLanguage === 'Spanish' ? 'es-ES' : 'en-US')}`)
            .join('\n')
          : '',
      });
      setShowModal2(true);
    } catch (err) {
      setModalError(t('errors.fetchShipmentDetailsFailed'));
    } finally {
      setModalLoading(false);
    }
  };

  const handleUpdateShipment = async (e) => {
    e.preventDefault();
    try {
      setModalLoading(true);
      setModalError(null);

      const requiredFields = ['Id', 'orderId', 'noOfPallets', 'goodsType', 'addOnDate', 'estimateDeliveryDate', 'status'];
      for (const field of requiredFields) {
        if (!formData[field]) {
          throw new Error(t('errors.requiredField', { field: t(`orders.${field}`) }));
        }
      }

      let intermediateDestinations = [];
      if (formData.intermediateDestinations && typeof formData.intermediateDestinations === 'string') {
        try {
          const lines = formData.intermediateDestinations.split('\n').filter(line => line.trim());
          intermediateDestinations = lines.map(line => {
            const [destination, time] = line.split(' - ').map(s => s.trim());
            if (!destination || !time) throw new Error(t('errors.invalidStopFormat'));
            return { destination, time: new Date(time).toISOString() };
          });
        } catch (err) {
          throw new Error(t('errors.invalidStopFormat'));
        }
      }

      const updateData = {
        Id: formData.Id,
        orderId: formData.orderId,
        noOfPallets: formData.noOfPallets,
        goodsType: formData.goodsType,
        addOnDate: formData.addOnDate,
        estimateDeliveryDate: formData.estimateDeliveryDate,
        store: formData.store || undefined,
        estimatedTimeAccurate: formData.estimatedTimeAccurate || undefined,
        status: formData.status,
        intermediateDestinations: intermediateDestinations.length > 0 ? intermediateDestinations : undefined,
      };

      await updateShipmentDetails(selectedShipment._id, updateData);
      const shipmentData = await getAllShipment({ page: currentPage, limit: 10 });
      setShipments(shipmentData.docs || []);

      setTotalPages(shipmentData.totalPages || 1);
      setTotalDocs(shipmentData.totalDocs || 0);
      setHasPrevPage(shipmentData.hasPrevPage || false);
      setHasNextPage(shipmentData.hasNextPage || false);

      setShowModal2(false);
      setSelectedShipment(null);
    } catch (err) {
      setModalError(t('errors.error', { message: err.message }));
    } finally {
      setModalLoading(false);
    }
  };

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const fetchDrivers = async () => {
      setLoadingDrivers(true);
      setDriverError('');
      try {
        const rawDrivers = await getTeamMembers();
        if (!Array.isArray(rawDrivers)) {
          throw new Error(t('errors.unexpectedApiResponse'));
        }
        const formattedDrivers = rawDrivers
          .filter((member) => member.userType?.toLowerCase() === 'driver')
          .map((member) => ({
            id: member._id,
            name: member.fullName || t('orders.unnamedDriver'),
            avatar: member.image || '/path/to/default-avatar.jpg',
          }));
        if (formattedDrivers.length === 0) {
          setDriverError(t('errors.noDriversFound'));
        } else {
          setDrivers(formattedDrivers);
          setFilteredDrivers(formattedDrivers);
        }
      } catch (err) {
        setDriverError(t('errors.fetchDriversFailed', { message: err.message }));
      } finally {
        setLoadingDrivers(false);
      }
    };
    fetchDrivers();
  }, [t]);

  useEffect(() => {
    setFilteredDrivers(
      drivers.filter(
        (driver) =>
          driver.name.toLowerCase().includes(search.toLowerCase()) ||
          driver.id.includes(search)
      )
    );
  }, [search, drivers]);

  const handleInputChange = (e, field, index = null) => {
    if (index !== null) {
      const newIntermediates = [...formData.intermediateDestinations];
      newIntermediates[index][field] = e.target.value;
      setFormData({ ...formData, intermediateDestinations: newIntermediates });
    } else {
      setFormData({ ...formData, [field]: e.target.value });
    }
  };

  const addIntermediateStop = () => {
    setFormData({
      ...formData,
      intermediateDestinations: [...formData.intermediateDestinations, { destination: '', time: '', lat: '', lng: '' }],
    });
  };

  const openMapModal = (type, index = null) => {
    setMapType(type);
    setMapIndex(index);
    setShowMapModal(true);
  };

  useEffect(() => {
    if (showMapModal && mapRef.current) {
      const map = L.map(mapRef.current).setView([51.505, -0.09], 13); // Default to London
      mapInstanceRef.current = map;
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      const onMapClick = (e) => {
        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }
        markerRef.current = L.marker([e.latlng.lat, e.latlng.lng]).addTo(map);
      };

      map.on('click', onMapClick);

      return () => {
        map.off('click', onMapClick);
        map.remove();
        mapInstanceRef.current = null;
      };
    }
  }, [showMapModal]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (mapSearchQuery.trim().length > 2) {
        setIsSearchingMap(true);
        try {
          const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(mapSearchQuery)}&limit=5`);
          const data = await response.json();
          setMapSuggestions(data || []);
        } catch (error) {
          console.error("Map search error:", error);
          setMapSuggestions([]);
        } finally {
          setIsSearchingMap(false);
        }
      } else {
        setMapSuggestions([]);
      }
    }, 600); // 600ms debounce

    return () => clearTimeout(delayDebounceFn);
  }, [mapSearchQuery]);

  const handleSelectMapSuggestion = (suggestion) => {
    setMapSearchQuery(suggestion.display_name);
    setMapSuggestions([]);
    
    const newLat = parseFloat(suggestion.lat);
    const newLng = parseFloat(suggestion.lon);
    
    if (mapInstanceRef.current) {
       mapInstanceRef.current.setView([newLat, newLng], 13);
       if (markerRef.current) {
         mapInstanceRef.current.removeLayer(markerRef.current);
       }
       markerRef.current = L.marker([newLat, newLng]).addTo(mapInstanceRef.current);
       markerRef.current.bindPopup(suggestion.display_name).openPopup();
    }
  };

  const handleMapSearchSubmit = async () => {
    if (!mapSearchQuery) return;
    if (mapSuggestions.length > 0) {
      handleSelectMapSuggestion(mapSuggestions[0]);
    } else {
      setIsSearchingMap(true);
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(mapSearchQuery)}`);
        const data = await response.json();
        if (data && data.length > 0) {
          handleSelectMapSuggestion(data[0]);
        } else {
          toast.error("Location not found");
        }
      } catch (error) {
        console.error("Map search error:", error);
        toast.error("Failed to search location");
      } finally {
        setIsSearchingMap(false);
      }
    }
  };

  const saveMapCoordinates = async () => {
    if (markerRef.current) {
      const { lat, lng } = markerRef.current.getLatLng();

      let addressStr = '';
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`);
        const data = await response.json();
        addressStr = data.display_name || '';
      } catch (error) {
        console.error('Error fetching address from map:', error);
      }

      if (mapType === 'origin') {
        setFormData((prev) => ({
          ...prev,
          originLat: lat.toString(),
          originLng: lng.toString(),
          origin: addressStr || prev.origin,
        }));
      } else if (mapType === 'destination') {
        setFormData((prev) => ({
          ...prev,
          destinationLat: lat.toString(),
          destinationLng: lng.toString(),
          destination: addressStr || prev.destination,
        }));
      } else if (mapType === 'intermediate' && mapIndex !== null) {
        setFormData((prev) => {
          const newIntermediates = [...prev.intermediateDestinations];
          newIntermediates[mapIndex] = {
            ...newIntermediates[mapIndex],
            lat: lat.toString(),
            lng: lng.toString(),
            destination: addressStr || newIntermediates[mapIndex].destination,
          };
          return { ...prev, intermediateDestinations: newIntermediates };
        });
      }
    }
    setShowMapModal(false);
    setMapType('');
    setMapIndex(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSuccess('');

      // Validate required Global fields
      const requiredFields = [
        'orderId', 'origin', 'originLat', 'originLng', 'destination', 'destinationLat', 'destinationLng',
        'goodsType', 'pickUpDate', 'dropOffDate', 'addOnDate', 'estimateDeliveryDate', 'status'
      ];

      for (const field of requiredFields) {
        if (!formData[field]) {
          toast.error(`${t('orders.' + field)} Required`, { position: "top-right" });
          return;
        }
      }

      // Validate each Container
      for (let i = 0; i < formData.containers.length; i++) {
        if (!formData.containers[i].containerNumber) {
          toast.error(`${t('orders.containerNumber')} Required for Row ${i + 1}`, { position: "top-right" });
          return;
        }
      }

      // Validate coordinate fields
      const isValidLatitude = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && isFinite(num) && num >= -90 && num <= 90;
      };

      const isValidLongitude = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && isFinite(num) && num >= -180 && num <= 180;
      };

      if (!isValidLatitude(formData.originLat) || !isValidLongitude(formData.originLng)) {
        toast.error(t('errors.invalidCoordinates', { field: 'Origin' }), { position: "top-right" });
        return;
      }

      if (!isValidLatitude(formData.destinationLat) || !isValidLongitude(formData.destinationLng)) {
        toast.error(t('errors.invalidCoordinates', { field: 'Destination' }), { position: "top-right" });
        return;
      }

      // Validate intermediate destinations
      const validatedIntermediateDestinations = formData.intermediateDestinations.map((stop, index) => {
        if (!stop.destination || !stop.time) {
          if (stop.destination === '' && stop.time === '' && formData.intermediateDestinations.length === 1) {
            return null;
          }
          toast.error(`Intermediate Stop ${index + 1} is incomplete`, { position: "top-right" });
          throw new Error('Validation failed');
        }

        if (!isValidLatitude(stop.lat) || !isValidLongitude(stop.lng)) {
          toast.error(`Invalid coordinates for Intermediate Stop ${index + 1}`, { position: "top-right" });
          throw new Error('Validation failed');
        }

        return {
          destination: stop.destination,
          time: stop.time,
          coordinates: {
            type: 'Point',
            coordinates: [parseFloat(stop.lng), parseFloat(stop.lat)]
          }
        };
      }).filter(Boolean);

      // Loop through containers and send 1-by-1 to backend
      const apiPromises = formData.containers.map((container) => {
        const submissionData = {
          ...formData,
          containerNumber: container.containerNumber,
          containerType: container.containerType,
          sealNumber: container.sealNumber,
          weight: container.weight,
          noOfPallets: container.noOfPallets,
          containerComments: container.containerComments,

          currentLocation: { type: 'Point', coordinates: [parseFloat(formData.originLng), parseFloat(formData.originLat)] },
          destinationLocation: { type: 'Point', coordinates: [parseFloat(formData.destinationLng), parseFloat(formData.destinationLat)] },
          intermediateDestinations: validatedIntermediateDestinations.length > 0 ? validatedIntermediateDestinations : undefined,

          containers: undefined
        };

        const fieldsToRemoveIfEmpty = [
          'driverId', 
          'driverContactNumber', 
          'vehicleNumber', 
          'containerType', 
          'sealNumber', 
          'weight', 
          'noOfPallets', 
          'containerComments',
          'sl',
          'terminal',
          'routeNotes'
        ];

        fieldsToRemoveIfEmpty.forEach(key => {
          if (submissionData[key] === null || submissionData[key] === undefined || submissionData[key] === '') {
            delete submissionData[key];
          }
        });

        return addShipment(submissionData);
      });

      await Promise.all(apiPromises);

      toast.success(t('orders.createShipmentSuccess'), { position: "top-right" });
      await fetchShipments(); // Refresh List
      
      openSuccessModal();
      setTimeout(() => {
        setShowModal(false);
        setFormData({
          importExportType: 'import',
          orderId: '',
          origin: '',
          originLat: '',
          originLng: '',
          destination: '',
          destinationLat: '',
          destinationLng: '',
          description: '',
          goodsType: '',
          pickUpDate: '',
          dropOffDate: '',
          pickUpHours: '',
          dropOffHours: '',
          companyType: "Dispax",
          containers: [{
            containerNumber: '', containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: ''
          }],
          length: '',
          commodity: '',
          intermediateDestinations: [{ destination: '', time: '', lat: '', lng: '' }],
          terminal: '',
          routeNotes: '',
          driverId: '',
          vehicleNumber: '',
          driverContactNumber: '',
          contactNumber: '',
          countryCode: '+1',
          currentLocation: { type: 'Point', coordinates: [0, 0] },
          destinationLocation: { type: 'Point', coordinates: [0, 0] },
          addOnDate: '',
          estimateDeliveryDate: '',
          portName: '',
          ticketNumber: '',
          bookingNumber: '',
          sl: '',
          price: '',
          isTracking: true,
          status: '',
        });
      }, 1000);

    } catch (err) {
      if (err.message !== 'Validation failed') {
        toast.error(err.message || t('orders.createShipmentFailed'), { position: "top-right" });
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef2.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(e.target) &&
        !buttonRef3.current.contains(e.target)
      ) {
        setShowDropdown2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarToggle = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: rect.height + 5,
        left: 0,
      });
    }
    setShowCalendar((prev) => !prev);
  };

  const toggleRegion = (region) => {
    setSelectedRegions(prev =>
      prev.includes(region)
        ? prev.filter(r => r !== region)
        : [...prev, region]
    );
  };

  const toggleStatus = (status) => {
    setSelectedStatuses(prev =>
      prev.includes(status)
        ? prev.filter(s => s !== status)
        : [...prev, status]
    );
  };

  const openSuccessModal = () => {
    setShowModal(false);
    setIsSuccessModalOpen(true);
  };

  // fetch shipping lines
  useEffect(() => {
    const fetchShippingLines = async () => {
      try {
        const lines = await getShippingLineList();
        setShippingLines(lines || []);
      } catch (error) {
        console.error("Error fetching shipping lines:", error);
      }
    };
    fetchShippingLines();
  }, []);

  const handleOpenModal = (shipmentId) => {
    setSelectedShipmentId(shipmentId);
    setShowSealModal(true);
  };

  const resetFilters = () => {
    setSelectedRegions([]);
    setSelectedStatuses([]);
    setSelectedDates([]);
    setCurrentPage(1);
  };
  
  const fetchShipments = async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        limit: 10,
      };

      if (selectedStatuses.length > 0) {
        params.status = selectedStatuses;
      }
      if (selectedRegions.length > 0) {
        params.origin = selectedRegions;
      }
      if (selectedDates.length > 0) {
        params.startDate = selectedDates[0]
          .toISOString()
          .split("T")[0];
      }

      const data = await getAllShipment(params);
      let docs = data?.docs || [];

      // 🔐 AI package condition
      if (userProfile?.isAiPackageExpired === false) {
        // AI package NOT active → only Dispax
        docs = docs.filter(
          (item) => item?.companyType === "Dispax"
        );
      }

      setShipments(docs);
      setTotalPages(data?.totalPages || 1);
      setTotalDocs(docs.length);
      setHasPrevPage(data?.hasPrevPage || false);
      setHasNextPage(data?.hasNextPage || false);
    } catch (err) {
      setError(t("errors.fetchShipmentsFailed"));
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchShipments();
  }, [
    currentPage,
    selectedDates,
    selectedRegions,
    selectedStatuses,
    userProfile?.isAiPackageExpired,
    t,
  ]);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const data = await getAllShipment({ limit: 1000 }); // Fetch a large number to get all options
        if (data && data.docs) {
          const origins = [...new Set(data.docs.map(shipment => shipment.origin))];
          const destinations = [...new Set(data.docs.map(shipment => shipment.destination))];
          const allLocations = [...new Set([...origins, ...destinations])].filter(Boolean);
          setUniqueLocations(allLocations);

          const statuses = [...new Set(data.docs.map(shipment => shipment.status))].filter(Boolean);
          setUniqueStatuses(statuses);
        }
      } catch (error) {
        console.error("Error fetching filter options:", error);
      }
    };
    fetchFilterOptions();
  }, []);

  const handlePrevPage = () => {
    if (hasPrevPage) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleInputChanges = (e, index = null, dispatchType) => {
    const { name, value } = e.target;

    setFormDatas(prev => {
      const updatedForm = { ...prev };
      const lowerDispatchType = dispatchType?.toLowerCase();

      if (!lowerDispatchType || !updatedForm[lowerDispatchType]) {
        return prev;
      }

      if (name.startsWith('intermediateDestinations')) {
        const [, idx, subField] = name.split('.');
        const destinationIndex = parseInt(idx);
        const newIntermediates = [...(updatedForm[lowerDispatchType].intermediateDestinations || [])];
        if (!newIntermediates[destinationIndex]) {
          newIntermediates[destinationIndex] = { destination: '', time: '', stopType: '' };
        }
        newIntermediates[destinationIndex][subField] = value || '';
        updatedForm[lowerDispatchType].intermediateDestinations = newIntermediates;

      } else if (name.startsWith('containers.')) {
        const [, idx, subField] = name.split('.');
        const containerIndex = parseInt(idx);
        const newContainers = [...(updatedForm.export?.containers || [])];
        if (!newContainers[containerIndex]) newContainers[containerIndex] = {};
        newContainers[containerIndex][subField] = value || '';
        updatedForm.export.containers = newContainers;

      } else {
        updatedForm[lowerDispatchType][name] = value || '';
      }
      return updatedForm;
    });
  };

  const addIntermediateDestination = (dispatchType) => {
    const lowerDispatchType = dispatchType.toLowerCase();
    setFormDatas(prev => ({
      ...prev,
      [lowerDispatchType]: {
        ...prev[lowerDispatchType],
        intermediateDestinations: [
          ...prev[lowerDispatchType].intermediateDestinations,
          { destination: '', time: '', stopType: '' },
        ],
      },
    }));
  };

  const removeIntermediateDestination = (index, dispatchType) => {
    const lowerDispatchType = dispatchType.toLowerCase();
    setFormDatas(prev => {
      const newStops = prev[lowerDispatchType].intermediateDestinations.filter((_, i) => i !== index);
      return {
        ...prev,
        [lowerDispatchType]: {
          ...prev[lowerDispatchType],
          intermediateDestinations: newStops,
        },
      };
    });
  };

  function removeEmpty(obj) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => {
          if (v === null || v === undefined) return false;
          if (typeof v === 'string' && v.trim() === '') return false;
          if (Array.isArray(v) && v.length === 0) return false;
          if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return false;
          return true;
        })
        .map(([k, v]) => {
          if (typeof v === 'object' && !Array.isArray(v)) {
            return [k, removeEmpty(v)];
          }
          if (Array.isArray(v)) {
            return [
              k,
              v.map(item => (typeof item === 'object' ? removeEmpty(item) : item))
                .filter(item => {
                  if (item === null || item === undefined) return false;
                  if (typeof item === 'string' && item.trim() === '') return false;
                  if (typeof item === 'object' && Object.keys(item).length === 0) return false;
                  return true;
                }),
            ];
          }
          return [k, v];
        })
    );
  }
  const isValidDate = (dateString) => {
    if (!dateString) return true;
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date);
  };

  const handleSubmits = async (e, dispatchType) => {
    e.preventDefault();
    if (
      formDatas[dispatchType.toLowerCase()].loadDate &&
      !isValidDate(formDatas[dispatchType.toLowerCase()].loadDate)
    ) {
      Swal.fire(t('errors.error'), t('errors.invalidDate'), 'error');
      return;
    }
    try {
      let shipmentsPayload = [];
      let shipmentId = '';
      const dispatchMode = formDatas[selectedType.toLowerCase()]?.dispatchMode;

      let payload = {
        shipmentId,
        shipments: shipmentsPayload,
        dispatchType: selectedShipping,
        dispatchMode: dispatchMode,
        importExportType:
          (dispatchType === 'Import' || dispatchType === 'Export'
            ? dispatchType.toLowerCase()
            : 'Disptach'),
        shippingMethod: formDatas[dispatchType.toLowerCase()].shippingMethod,
        shippingMethod1: formDatas[dispatchType.toLowerCase()].shippingMethod1,
        status: 'Pending',
        commodity: formDatas[dispatchType.toLowerCase()].commodity,
        origin: formDatas[dispatchType.toLowerCase()].loadAddress || 'Los Angeles, CA',
        size: formDatas[dispatchType.toLowerCase()].size || null,
        returnFull: formDatas[dispatchType.toLowerCase()].returnFull,
        loadTime: formDatas[dispatchType.toLowerCase()].loadTime,
        loadAddress: formDatas[dispatchType.toLowerCase()].loadAddress,
        loadDate: formDatas[dispatchType.toLowerCase()].loadDate
          ? new Date(formDatas[dispatchType.toLowerCase()].loadDate).toISOString()
          : null,
        trailerNumber:
          dispatchType === 'LTL' || dispatchType === 'FTL'
            ? formDatas[dispatchType.toLowerCase()].trailerNumber
            : null,
        bookingNumber: formDatas[dispatchType.toLowerCase()].bookingNumber,
        destination: formDatas[dispatchType.toLowerCase()].destination,
        pinNumber: formDatas[dispatchType.toLowerCase()].pinNumber,
        importLocation: formDatas[dispatchType.toLowerCase()].importLocation,
        sealNumber: formDatas[dispatchType.toLowerCase()].sealNumber,

        poNumber: formDatas[dispatchType.toLowerCase()].poNumber,
        flatBeds: formDatas[dispatchType.toLowerCase()].flatBeds,
        sl: formDatas[dispatchType.toLowerCase()].sl,
        intermediateDestinations: formDatas[
          dispatchType.toLowerCase()
        ].intermediateDestinations
          .map(stop => ({
            destination: stop.destination,
            time: stop.time,
            stopType: stop.stopType || '',
          }))
          .filter(stop => stop.destination && stop.time),
      };

      payload = removeEmpty(payload);

      await addDispatchShipment(payload);
      Swal.fire(
        t('orders.successfully'),
        t(`orders.create${dispatchType}Dispatch`),
        'success'
      );
      setShowLTLModal(false);
      setShowFTLModal(false);
      setFormDatas(prev => ({
        ...prev,
        [dispatchType.toLowerCase()]: {
          shippingMethod: '',
          shippingMethod1: '',
          pickEmpty: '',
          sl: '',
          size: '',
          loadDate: '',
          loadTime: '',
          loadAddress: '',
          commodity: '',
          returnFull: '',
          trailerNumber: '',
          bookingNumber: '',
          destination: '',
          pinNumber: '',
          importLocation: '',
          poNumber: '',
          flatBeds: '',
          dispatchMode: '',
          intermediateDestinations: [
            { destination: '', time: '', stopType: '' },
          ],
          containers:
            dispatchType === 'Export'
              ? [
                {
                  bookingNumber: '',
                  size: '',
                  pickEmpty: '',
                  commodity: '',
                  returnFull: '',
                },
              ]
              : undefined,
        },
      }));
      setSelectedDriver(null);
      setSelectedType('');
      setSelectedShipping('');
      fetchShipments(); // Refresh UI list 
    } catch (error) {
      console.error(`Error creating ${dispatchType} dispatch:`, error);
      let errorMessage = t('errors.createDispatchFailed', { dispatchType });
      if (error.response?.data?.errors) {
        errorMessage = Object.entries(error.response.data.errors)
          .map(([field, err]) => `${field}: ${err.message || err}`)
          .join('\n');
      } else if (error.message) {
        errorMessage = t('errors.error', { message: error.message });
      }
      Swal.fire(t('errors.error'), errorMessage, 'error');
    }
  };

  const handleOpenSealModal = (id) => {
    setSelectedShipmentId(id);
    setShowSealModal(true);
  };

  const refreshShipments = () => {
    fetchShipments();
  };

  // --- NEW: ASSIGN DRIVER FUNCTION ---
  const handleAssignDriverSubmit = async () => {
    if (!assigningDriverId || !assigningShipmentId) return;
    setIsAssigning(true);
    try {
      // Body payload has driverId as per curl request
      await assignedShipmentToDriver(assigningShipmentId, { driverId: assigningDriverId });
      toast.success(t('orders.driverAssignedSuccessfully', 'Driver assigned successfully!'), { position: "top-right" });
      setShowDriverModal(false);
      setAssigningDriverId('');
      fetchShipments(); // Refresh table data
    } catch (err) {
      console.error("Assign driver error:", err);
      toast.error(err?.response?.data?.message || t('errors.assignDriverFailed', 'Failed to assign driver'), { position: "top-right" });
    } finally {
      setIsAssigning(false);
    }
  };

  return (
    <div className="text-white px-1 sm:px-4">
      <div className="flex flex-col sm:flex-row items-center justify-between mb-6">
        <h1 className="text-2xl sm:text-xl font-semibold mb-4 sm:mb-0">
          {t('orders.title')}
        </h1>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between mb-6 gap-4">
        <div className="flex flex-col sm:flex-row items-center bg-[#10194E] rounded-xl shadow-md w-full sm:w-auto">
          <div className="flex items-center gap-2 px-4 py-3 sm:py-5 border-b sm:border-b-0 sm:border-r border-[#1E2A60] text-white w-full sm:w-auto">
            <FiFilter className="text-lg sm:text-base" />
            <span className="text-sm">{t('orders.filterBy')}</span>
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef}
              onClick={handleCalendarToggle}
              className="px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] bg-transparent text-white w-full sm:w-auto text-left sm:text-center"
            >
              {selectedDates.length > 0
                ? selectedDates.map((date) => format(date, "PP", { locale: selectedLanguage === 'Spanish' ? es : undefined })).join(", ")
                : t('orders.date')}
            </button>
            {showCalendar && (
              <div
                ref={calendarRef}
                className="absolute left-0 sm:left-9 sm:-translate-x-24 p-4 shadow-lg rounded z-50 w-[90%] sm:w-auto"
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
              >
                <DayPicker
                  mode="multiple"
                  selected={selectedDates}
                  onSelect={setSelectedDates}
                  locale={selectedLanguage === 'Spanish' ? es : undefined}
                  footer={
                    <div className="pt-4">
                      <div className="flex justify-start">
                        <span className="text-xs sm:text-sm text-gray-400">
                          {t('orders.multipleDates')}
                        </span>
                      </div>
                    </div>
                  }
                />
              </div>
            )}
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef2}
              onClick={() => setShowDropdown(!showDropdown)}
              className="bg-transparent text-white px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
            >
              {t('orders.location')}
            </button>
            {showDropdown && (
              <div
                ref={dropdownRef}
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
                className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-50 shadow-lg"
              >
                <h2 className="text-base sm:text-lg font-semibold mb-4">
                  {t('orders.location')}
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                  {uniqueLocations.map((location) => (
                    <button
                      key={location}
                      onClick={() => toggleRegion(location)}
                      className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedRegions.includes(location)
                        ? "bg-white text-black font-semibold"
                        : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                        }`}
                    >
                      {location}
                    </button>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-300 mb-3">
                  {t('orders.multipleLocations')}
                </p>
              </div>
            )}
          </div>

          <div className="relative w-full sm:w-auto">
            <button
              ref={buttonRef3}
              onClick={() => setShowDropdown2(!showDropdown2)}
              className="bg-transparent text-white px-4 py-3 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
            >
              {t('orders.statusLabel')}
            </button>
            {showDropdown2 && (
              <div
                ref={dropdownRef2}
                style={{
                  background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                }}
                className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-50 shadow-lg"
              >
                <h2 className="text-base sm:text-lg font-semibold mb-4">
                  {t('orders.selectOrderStatus')}
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                  {uniqueStatuses.map((status) => (
                    <button
                      key={status}
                      onClick={() => toggleStatus(status)}
                      className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedStatuses.includes(status)
                        ? "bg-white text-black font-semibold"
                        : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                        }`}
                    >
                      {t(`orders.status.${status.toLowerCase()}`, { defaultValue: status })}
                    </button>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-300 mb-3">
                  {t('orders.multipleOrderStatus')}
                </p>
              </div>
            )}
          </div>
          <button
            onClick={resetFilters}
            className="flex items-center gap-1 px-4 py-3 sm:py-5 text-sm text-orange-400 hover:underline w-full sm:w-auto text-left sm:text-center"
          >
            <FiRotateCw className="text-sm" />
            {t('orders.resetFilter')}
          </button>
        </div>

        <button
          disabled={!(userProfile?.packageId || userProfile?.aiPackageId)}
          onClick={() => setShowModal(true)}
          className={`bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-4 sm:px-5 py-2 rounded-xl text-white font-medium flex items-center gap-2 shadow-md w-full sm:w-auto mt-4 sm:mt-0 ${!(userProfile?.packageId || userProfile?.aiPackageId) ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}`}
        >
          <FiPlus className="text-md sm:text-base" />
          {t('orders.createNewDispatch')}
        </button>
      </div>
      
      {showModal && (
        <CreateContainerModal  
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
          handleContainerChange={handleContainerChange}
          addContainerRow={addContainerRow}
          removeContainerRow={removeContainerRow}
          onSubmit={handleSubmit}
          onClose={() => setShowModal(false)}
          openFTL={() => {
            setShowModal(false);
            setShowFTLModal(true);
          }}
          openLTL={() => {
            setShowModal(false);
            setShowLTLModal(true);
          }}
          openMap={(type, index = null) => {
            openMapModal(type, index);
          }}
          fetchShipments={fetchShipments}
          initialTab={formData.importExportType === 'export' ? 'Export' : 'Import'}
        />
      )}

      {/* --- MAP MODAL --- */}
      {showMapModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
          <div
            className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-[90%] sm:w-[80%] max-w-[480px] h-[480px]"
            style={{
              background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
            }}
          >
            <button
              onClick={() => setShowMapModal(false)}
              className="absolute top-2 right-4 text-2xl sm:text-xl font-bold"
            >
              ×
            </button>
            <h2 className="text-lg font-bold mb-4">
              {t(`orders.select${mapType.charAt(0).toUpperCase() + mapType.slice(1)}Location`)}
            </h2>
            
            <div className="flex mb-4 gap-2 relative">
              <input
                 type="text"
                 placeholder="Search Zip Code or Location"
                 value={mapSearchQuery}
                 onChange={(e) => setMapSearchQuery(e.target.value)}
                 onKeyDown={(e) => e.key === 'Enter' && handleMapSearchSubmit()}
                 className="flex-1 px-3 py-2 rounded bg-white text-black outline-none text-sm"
              />
              <button
                 onClick={handleMapSearchSubmit}
                 className="bg-[#6F1AFF] hover:bg-[#5C10E6] px-4 py-2 rounded text-white text-sm flex items-center justify-center min-w-[80px]"
              >
                {isSearchingMap ? <Loader2 className="animate-spin text-white" size={16} /> : "Search"}
              </button>

              {/* DROPDOWN SUGGESTIONS */}
              {mapSuggestions.length > 0 && (
                <div className="absolute top-full left-0 w-[calc(100%-88px)] mt-1 bg-white shadow-2xl rounded-md z-50 max-h-48 overflow-y-auto text-black border border-gray-200">
                  {mapSuggestions.map((suggestion, index) => (
                    <div 
                      key={index} 
                      className="px-3 py-2 text-sm hover:bg-violet-50 cursor-pointer border-b last:border-b-0 border-gray-100 transition-colors"
                      onClick={() => handleSelectMapSuggestion(suggestion)}
                    >
                      {suggestion.display_name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div ref={mapRef} style={{ height: '280px', width: '100%', zIndex: 1, borderRadius: '8px' }}></div>
            <div className="flex justify-center mt-4">
              <button
                onClick={saveMapCoordinates}
                className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90"
              >
                {t('orders.saveLocation')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- SUCCESS MODAL --- */}
      {isSuccessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-[#0F0D2E] p-6 sm:p-8 rounded-2xl w-full max-w-[90%] sm:max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
            <h2 style={{ fontFamily: "Poppins" }} className="text-[24px] sm:text-[30px] font-bold text-white leading-tight">
              {t('orders.assigned')} <span className="text-[30px] sm:text-[45px] text-[#6F1AFF]">{t('orders.successfully')}</span>
            </h2>
            <p className="text-xs sm:text-sm text-gray-400 mb-4 sm:mb-6 mt-1">
              {t('orders.successMessage')}
            </p>
            <div className="flex justify-center mb-4 sm:mb-6">
              <img src={check} alt={t('alt.checkmark')} className="w-[150px] sm:w-[197px] h-[120px] sm:h-[156px]" />
            </div>
            <button
              onClick={() => setIsSuccessModalOpen(false)}
              className="w-full py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm"
            >
              {t('orders.ok')}
            </button>
          </div>
        </div>
      )}

      {/* --- TABLE --- */}
      <div className="overflow-x-auto bg-[#1D2461] rounded-lg mt-4">
        <table className="w-full table-auto text-sm text-left min-w-[640px]">
          <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[12px] sm:text-[14px]">
            <tr>
              <th className="p-2 sm:p-4"></th>
              <th className="p-2 sm:p-4">{t("orders.containerId")}</th>
              <th className="p-2 sm:p-4">{t("orders.purchaseOrderNo")}</th>
              <th className="p-2 sm:p-4">{t("orders.originDestination")}</th>
              <th className="p-2 sm:p-4">{t("orders.importExportType.import")}</th>
              <th className="p-2 sm:p-4">{t("orders.sealNumber")}</th>
              <th className="p-2 sm:p-4">{t("orders.statusLabel")}</th>
              <th className="p-2 sm:p-4">{t("orders.actions")}</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr className="border-t border-[#2A2A4D]">
                <td colSpan="9" className="p-2 sm:p-4 text-center">
                  <div className="flex justify-center">
                    <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
            ) : shipments.length > 0 ? (
              shipments.map((row) => (
                <tr key={row._id} className="border-t border-[#2A2A4D]">
                  <td className="p-2 sm:p-4">
                    <input type="checkbox" />
                  </td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">{row.Id}</td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">{row.orderId}</td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm max-w-[200px] sm:max-w-[300px] truncate relative group cursor-pointer">
                    {row.origin} → {row.destination}
                    
                    <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block w-max max-w-xs sm:max-w-md bg-[#101533] text-white text-xs p-3 rounded-lg shadow-2xl border border-[#2A2A4D] z-50 whitespace-normal break-words">
                      <p><span className="font-semibold text-cyan-400">Origin:</span> {row.origin}</p>
                      <p className="mt-1"><span className="font-semibold text-purple-400">Destination:</span> {row.destination}</p>
                      {/* Triangle pointer */}
                      <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-[#2A2A4D]"></div>
                    </div>
                  </td>
                  <td className="p-2 sm:p-4 text-xs sm:text-sm">
                    {t(
                      `orders.importExportType.${row?.importExportType?.toLowerCase?.() ?? "unknown"}`,
                      { defaultValue: row?.importExportType ?? "N/A" }
                    )}
                  </td>

                  <td className="p-2 sm:p-4 text-xs sm:text-sm">
                    {row.sealNumber ? row.sealNumber : t("orders.noSealNumber")}
                  </td>

                  <td className="p-2 sm:p-4">
                    <span className="inline-flex items-center gap-2 text-xs sm:text-sm">
                      <span
                        className={`w-2 sm:w-3 h-2 sm:h-3 rounded-full ${statusColors[row.status] || "bg-gray-500"
                          }`}
                      ></span>
                      {t(`orders.status.${row.status.toLowerCase()}`, {
                        defaultValue: row.status,
                      })}
                    </span>
                  </td>

                  {/* --- ACTIONS COLUMN --- */}
                  <td className="p-2 sm:p-4 flex flex-wrap gap-2">
                    <button
                      onClick={() => handleViewShipment(row._id)}
                      className="bg-[#00B69B] text-white px-3 sm:px-4 py-1 rounded-2xl hover:bg-blue-600 text-xs sm:text-sm whitespace-nowrap"
                    >
                      {t("orders.view")}
                    </button>

                    <button
                      onClick={() => handleOpenSealModal(row._id)}
                      className="bg-[#6F1AFF] text-white px-3 sm:px-4 py-1 rounded-2xl hover:opacity-90 text-xs sm:text-sm"
                    >
                      {row.sealNumber ? t("orders.updateSealNumberButton", "Update Seal Number") : t("orders.addSealNumberButton", "Add Seal Number")}
                    </button>

                    {/* NEW: Assign Driver Button */}
                    {!row.driverId && (
                      <button
                        onClick={() => {
                          setAssigningShipmentId(row._id);
                          setAssigningDriverId(""); 
                          setShowDriverModal(true);
                        }}
                        className="bg-orange-500 text-white px-3 sm:px-4 py-1 rounded-2xl hover:bg-orange-600 text-xs sm:text-sm whitespace-nowrap"
                      >
                        {t("orders.assignDriver", "Assign Driver")}
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="border-t border-[#2A2A4D]">
                <td colSpan="9" className="p-2 sm:p-4 text-center text-xs sm:text-sm">
                  {t("orders.noShipmentsFound")}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* --- PAGINATION --- */}
        <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-gray-400 p-2 sm:p-4">
          <div className="mb-2 sm:mb-0">
            {t('orders.showing', {
              start: shipments.length > 0 ? (currentPage - 1) * 10 + 1 : 0,
              end: shipments.length > 0 ? Math.min(currentPage * 10, totalDocs) : 0,
              total: totalDocs,
            })}
          </div>
          <div className="flex gap-2 sm:gap-4">
            <button
              onClick={handlePrevPage}
              disabled={!hasPrevPage}
              className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm ${hasPrevPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            >
              {t('orders.previous')}
            </button>
            <button
              onClick={handleNextPage}
              disabled={!hasNextPage}
              className={`px-3 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm ${hasNextPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            >
              {t('orders.next')}
            </button>
          </div>
        </div>
      </div>

      {/* --- EDIT SHIPMENT MODAL --- */}
      {showModal2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div
            className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-[90%] sm:w-[80%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
            }}
          >
            <button
              onClick={() => {
                setShowModal2(false);
                setSelectedShipment(null);
              }}
              className="absolute top-2 right-4 text-2xl sm:text-xl font-bold"
            >
              ×
            </button>

            <h2 className="text-xl sm:text-lg font-bold mb-4">
              {t('orders.detailedContainerView')}
            </h2>

            {modalLoading ? (
              <div className="flex justify-center">
                <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
              </div>
            ) : (
              <form className="space-y-3 sm:space-y-4" onSubmit={handleUpdateShipment}>
                <h3 className="text-sm text-cyan-400 font-semibold">
                  {t('orders.shipmentOverview')}
                </h3>
                {/* Inputs for updating... (preserved as is) */}
                <div>
                  <label className="text-sm block mb-1">{t('orders.containerId')}</label>
                  <input name="Id" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.Id} onChange={handleInputChange2} />
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('orders.orderId')}</label>
                  <input name="orderId" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.orderId} onChange={handleInputChange2} />
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('orders.noOfPallets')}</label>
                  <input name="noOfPallets" type="number" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.noOfPallets} onChange={handleInputChange2} />
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('orders.goodsType')}</label>
                  <select name="goodsType" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.goodsType} onChange={handleInputChange2}>
                    <option value="">{t('orders.selectGoodsType')}</option>
                    <option value="Electronics">{t('orders.goodsTypeOptions.electronics')}</option>
                    <option value="Textile">{t('orders.goodsTypeOptions.textile')}</option>
                    <option value="Food">{t('orders.goodsTypeOptions.food')}</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('orders.addedOn')}</label>
                  <input name="addOnDate" type="datetime-local" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.addOnDate} onChange={handleInputChange2} />
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('orders.estimatedDeliveryDate')}</label>
                  <input name="estimateDeliveryDate" type="datetime-local" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.estimateDeliveryDate} onChange={handleInputChange2} />
                </div>
                <div>
                  <label className="text-sm block mb-1">{t('Status')}</label>
                  <select name="status" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.status} onChange={handleInputChange2}>
                    <option value="">{t('orders.selectStatus')}</option>
                    <option value="Pending">{t('orders.status.pending')}</option>
                    <option value="In Transit">{t('orders.status.inTransit')}</option>
                    <option value="Delivered">{t('orders.status.delivered')}</option>
                  </select>
                </div>
                <h3 className="text-sm text-cyan-400 font-semibold mt-3 sm:mt-4">{t('orders.stopsList')}</h3>
                <div>
                  <label className="text-sm block mb-1">{t('orders.stopsList')}</label>
                  <textarea name="intermediateDestinations" rows="4" className="w-full px-3 py-2 rounded bg-white text-black text-sm" value={formData.intermediateDestinations} onChange={handleInputChange2} />
                </div>
                <button type="submit" className="w-full py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm" disabled={modalLoading}>
                  {t('orders.update')}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* --- FTL MODAL --- */}
      {showFTLModal && (
        <FTLModal 
          onClose={() => setShowFTLModal(false)} 
          openImport={() => { setShowFTLModal(false); setFormData(prev => ({...prev, importExportType: 'import'})); setShowModal(true); }}
          openExport={() => { setShowFTLModal(false); setFormData(prev => ({...prev, importExportType: 'export'})); setShowModal(true); }}
          openLTL={() => { setShowFTLModal(false); setShowLTLModal(true); }}
        />
      )}

      {/* --- LTL MODAL --- */}
      {showLTLModal && (
        <LTLModal 
          onClose={() => setShowLTLModal(false)} 
          openImport={() => { setShowLTLModal(false); setFormData(prev => ({...prev, importExportType: 'import'})); setShowModal(true); }}
          openExport={() => { setShowLTLModal(false); setFormData(prev => ({...prev, importExportType: 'export'})); setShowModal(true); }}
          openFTL={() => { setShowLTLModal(false); setShowFTLModal(true); }}
        />
      )}

      {/* --- UPDATE SEAL MODAL --- */}
      <UpdateSealNumberModal
        show={showSealModal}
        onClose={() => setShowSealModal(false)}
        shipmentId={selectedShipmentId}
        onSuccess={refreshShipments}
      />

      {/* --- NEW: ASSIGN DRIVER MODAL --- */}
      {showDriverModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div 
            className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-md border border-[#2A2A4D]"
            style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold">{t("orders.assignDriver", "Assign Driver")}</h2>
              <button onClick={() => setShowDriverModal(false)} className="text-gray-400 hover:text-white transition">
                <FiX size={24} />
              </button>
            </div>
            
            <div className="mb-6">
              <label className="text-sm block mb-2 text-gray-300">{t("orders.selectDriver", "Select Driver")}</label>
              <select
                value={assigningDriverId}
                onChange={(e) => setAssigningDriverId(e.target.value)}
                className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none cursor-pointer"
              >
                <option value="" disabled>{t("orders.selectDriverPlaceholder", "-- Select Driver --")}</option>
                {drivers.map(driver => (
                  <option key={driver.id} value={driver.id}>
                    {driver.name}
                  </option>
                ))}
              </select>
            </div>
            
            <button
              onClick={handleAssignDriverSubmit}
              disabled={isAssigning || !assigningDriverId}
              className="w-full py-2.5 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm flex justify-center items-center gap-2 shadow-lg disabled:opacity-50"
            >
              {isAssigning ? <Loader2 className="animate-spin" size={18} /> : t("orders.confirmAssignment", "Confirm Assignment")}
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default OrdersContainers;